import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(user)/t/$tenantSlug/subscription")({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello Subscription!</div>
}
